import { render } from "./LatestPostsComponent.vue?vue&type=template&id=6bbd66aa&scoped=true"
import script from "./LatestPostsComponent.vue?vue&type=script&lang=js"
export * from "./LatestPostsComponent.vue?vue&type=script&lang=js"

import "./LatestPostsComponent.vue?vue&type=style&index=0&id=6bbd66aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbd66aa"]])

export default __exports__